var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{attrs:{"value":_vm.content,"extensions":_vm.extensions,"toolbar-attributes":_vm.color},on:{"input":function($event){return _vm.onUpdate('content', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }